import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button } from "@material-ui/core";
import { buildZendeskLink } from "src/store/adminHtml/selector";
import { openZendeskWithSSO } from "src/utils/zendeskSso";
import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "src/store/system/selector";

const useStyles = makeStyles((theme) => ({
  minimalMarginBottom: {
    marginBottom: theme.spacing(1),
  },
  importantText: {
    fontWeight: theme.typography.fontWeightBold,
  },
  headerText: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  textField: {
    marginTop: theme.spacing(1),
    width: "100%",
  },
  singlePaddingLeft: {
    paddingLeft: theme.spacing(1),
  },
  singlePaddingTop: {
    paddingTop: theme.spacing(1),
  },
}));

interface DifficultyActionDialogProps {
  cancellationReason: string;
  setCancellationReason: (reason: string) => void;
}

function DifficultyActionDialog(props: DifficultyActionDialogProps) {
  const classes = useStyles();
  const user = useSelector(selectUser);
  if (!user) return null;

  return (
    <div>
      <Box pb={0.5}>
        <Typography variant="h4" className={classes.headerText}>
          We’re here to help - let’s find a solution to the problem you’re
          facing.
        </Typography>
        <Typography variant="body1">
          Did you know? Our customer success team responds to emails and
          messages in 24 hours or less. Need some clarification on a topic in
          MRG? Click “Contact Support” to send us a message.
        </Typography>
        <div className={classes.singlePaddingTop}>
          <Button
            color="primary"
            variant="contained"
            onClick={() =>
              openZendeskWithSSO(
                buildZendeskLink(
                  user,
                  "Having Difficulty Using MRG",
                  "Please use this description box to outline the problems you are facing below:",
                  "cancellationReason:difficultyAction",
                  "cancelation"
                )
              )
            }
          >
            Contact Support
          </Button>
        </div>
      </Box>
      <div className={classes.singlePaddingTop}>
        <Typography>
          <Box component="span" fontWeight="fontWeightMedium">
            Before you click Cancel Subscription,
          </Box>{" "}
          we would love to know what would change your mind:
        </Typography>
      </div>
      <TextField
        id="filled-basic"
        label="Please Let Us Know"
        variant="filled"
        className={classes.textField}
        value={props.cancellationReason}
        onChange={(event) => {
          props.setCancellationReason(event.target.value);
        }}
      />
    </div>
  );
}

export default DifficultyActionDialog;
